var _style, _path, _path2, _path3, _linearGradient, _path4, _linearGradient2, _path5, _path6, _path7, _image, _image2, _path8, _path9, _linearGradient3, _path10, _path11, _linearGradient4, _path12, _linearGradient5, _path13, _path14, _linearGradient6, _path15, _linearGradient7, _path16, _linearGradient8, _path17, _linearGradient9, _path18, _linearGradient10, _path19, _linearGradient11, _path20, _linearGradient12, _path21, _path22, _path23, _path24, _path25, _path26, _linearGradient13, _path27, _linearGradient14, _path28, _path29, _path30, _linearGradient15, _path31;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopViewTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "top_view_truck_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 480.2 488.2",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".top_view_truck_svg__st0{fill:#0f4cf4}.top_view_truck_svg__st1{fill:#2355fc}.top_view_truck_svg__st2{fill:#f7941e}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st0",
    d: "M183.6 141.5c-1-5.1 1.6-20.7 1.6-20.7 0-14.7 24.2-21.5 37.6-21.5h34.5c13.4 0 37.6 6.7 37.6 21.5 0 0 2.6 15.6 1.6 20.7-.9 4.9-2 32.1-2 32.1h-109c.1.1-.9-27-1.9-32.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M257.1 99.4h-34c-13.2 0-37.9 6.5-37.9 20.8v2c0-5 1.8-8.6 4.8-11.1 5.7-5.8 15.7-8.6 27.2-8.6h45.7c11.5 0 21.6 2.8 27.2 8.6 3.1 2.5 4.8 6.1 4.8 11.1v-2c.1-14.3-24.7-20.8-37.8-20.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st2",
    d: "M289.6 123.3c-.5-.1-.9-.5-.9-1.1 0-2.1-.8-4.1-2.2-5.6-.4-.4-.4-1-.1-1.4.3-.4 1-.4 1.5.1 1.7 1.9 2.7 4.3 2.7 6.8 0 .8-.5 1.3-1 1.2zM190.6 123.3c.5-.1.9-.5.9-1.1 0-2.1.8-4.1 2.2-5.6.4-.4.4-1 .1-1.4-.3-.4-1-.4-1.5.1-1.7 1.9-2.7 4.3-2.7 6.8 0 .8.5 1.3 1 1.2z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.774,
    y1: 110.688,
    x2: 287.315,
    y2: 110.688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbdbdb"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274 106.4s-.7-.7.5-.8c1.2-.1 7.6.3 11 5.1 3.4 4.9.9 5 .9 5l-12.4-9.3z",
    fill: "url(#top_view_truck_svg__SVGID_1_)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.688,
    y1: 110.688,
    x2: 205.636,
    y2: 110.688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbdbdb"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.3 106.4s.7-.7-.5-.8c-1.2-.1-7.6.3-11 5.1-3.4 4.9-.9 5-.9 5l12.4-9.3z",
    fill: "url(#top_view_truck_svg__SVGID_2_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M185.1 139.9c-.4-5 6.1-19.7 6.1-19.7 4.3-13.8 18.6-14.9 26.1-14.9H263c7.4 0 21.7 1.1 26.1 14.9 0 0 6.4 14.7 6.1 19.7-.3 5-4.2 20.2-4.2 20.2l-97.8-.7c-.1-.1-7.7-14.3-8.1-19.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M272.4 139.6c-10.1 11.6-54.6 11.6-64.7 0-4.9-5.6 12.2-33.3 12.2-33.3h40.3s17.1 27.7 12.2 33.3z"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 75,
    height: 137,
    xlinkHref: "72934AC4A5C0E5C2.png",
    transform: "matrix(.24 0 0 .24 265.626 108.56)",
    overflow: "visible"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 75,
    height: 137,
    xlinkHref: "72934AC4A5C0E5C6.png",
    transform: "matrix(.24 0 0 .24 196.506 108.56)",
    overflow: "visible"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M190.6 209.4h98.8s5.2-3.9 5.2-5.7v-30c0-6.6-3.7-13.6-3.7-13.6s-9.6-6.6-50.8-6.4c-27.7-.1-43.4 4.3-50.3 7.1-3.3 1.4-4.2 7.7-4.2 12.9v30c0 4.2 5 5.7 5 5.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M195.6 209.4s-3.4-9.6-3.4-25.2c0-10.8 3.4-24.1 3.4-24.1 3.1-1.1 23.8-5.1 44.5-5.1s41.3 3.6 44.5 4.8c0 0 3.4 12.8 3.4 24.5 0 16.4-3.4 25.2-3.4 25.2h-89z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.515,
    y1: 81.759,
    x2: 272.138,
    y2: 106.199,
    gradientTransform: "rotate(1.403 -2404.476 1367.594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M290.6 143.6s5.9 1.3 5.9 6.1c0 4.9-6.3 14.6-6.2 8.3 0-6.1-.3-12.5.3-14.4z",
    fill: "url(#top_view_truck_svg__SVGID_3_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st0",
    d: "M310.9 154.4c-1.3-1.7-13.2-5.2-13.2-5.2-2.3-.7-3.2 1.3-3.4 3l17 5c.3-.9.3-1.9-.4-2.8z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.18,
    y1: 155.141,
    x2: 311.498,
    y2: 155.141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 152.1c-.2 1.1-.1 2.1-.1 2.1l16.7 4s.3-.5.4-1.1l-17-5z",
    fill: "url(#top_view_truck_svg__SVGID_4_)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 508.678,
    y1: 75.828,
    x2: 521.3,
    y2: 100.266,
    gradientTransform: "scale(-1 1) rotate(1.364 -2770.159 -29276.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.6 143.6s-5.9 1.3-5.9 6.1c0 4.9 6.3 14.6 6.2 8.3 0-6.1.2-12.5-.3-14.4z",
    fill: "url(#top_view_truck_svg__SVGID_5_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st0",
    d: "M169.2 154.4c1.3-1.7 13.2-5.2 13.2-5.2 2.3-.7 3.1 1.3 3.4 3l-17 5c-.2-.9-.3-1.9.4-2.8z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 543.411,
    y1: 155.141,
    x2: 560.726,
    y2: 155.141,
    gradientTransform: "matrix(-1 0 0 1 729.39 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.8 152.1c.2 1.1.1 2.1.1 2.1l-16.7 4s-.3-.5-.4-1.1l17-5z",
    fill: "url(#top_view_truck_svg__SVGID_6_)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.924,
    y1: 105.603,
    x2: 260.242,
    y2: 105.603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c0d0d"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top_view_truck_svg__SVGID_7_)",
    d: "M260.2 106.3h-40.3l2.5-1.4h35.4z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.315,
    y1: 173.68,
    x2: 311.683,
    y2: 222.796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M289.6 203.6l5-5.2v-.7-24s.1-2.9.3-7l-5.4 4.9c.1-.1 2.6 15.2.1 32z",
    fill: "url(#top_view_truck_svg__SVGID_8_)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.185,
    y1: 183.547,
    x2: 304.865,
    y2: 215.842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M294.6 198.4v-19.9c-1.3 1-2.7 2.1-4.1 3.2.3 5.9.3 13.7-1 22l5.1-5.3z",
    fill: "url(#top_view_truck_svg__SVGID_9_)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.514,
    y1: 172.197,
    x2: 210.505,
    y2: 228.328
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M190.6 203.6c-2.6-16.8 0-32.1 0-32.1l-5.3-4.3c.2 3.8.3 6.4.3 6.4v24.7l5 5.3z",
    fill: "url(#top_view_truck_svg__SVGID_10_)"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.071,
    y1: 182.741,
    x2: 194.563,
    y2: 195.952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b3b3b"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.6 198.4v-19.9c1.3 1 2.7 2.1 4.1 3.2-.3 5.9-.3 13.7 1 22l-5.1-5.3z",
    fill: "url(#top_view_truck_svg__SVGID_11_)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.619,
    y1: 210.921,
    x2: 289.551,
    y2: 210.921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c0d0d"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top_view_truck_svg__SVGID_12_)",
    d: "M190.6 209.4h98.9v3.1h-98.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M280.4 138.4c-14.3-5.9-30.2-9-46.8-8.6v-2c16.9-.4 33 2.7 47.5 8.7-.2.7-.4 1.3-.7 1.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M250.9 130c0 1.2-5.2 2.1-11.5 2.1-6.4 0-11.5-.9-11.5-2.1 0-1.2 5.2-2.1 11.5-2.1s11.5.9 11.5 2.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M294.4 195.1c.6 0 1-.5 1-1.1v-8.9c0-.6-.5-1.1-1-1.1v11.1z",
    fill: "#e3e3e3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M185.6 195.1c-.6 0-1-.5-1-1.1v-8.9c0-.6.5-1.1 1-1.1v11.1z",
    fill: "#c9c9c9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M240.1 154.3c-15.9 0-45.6 4.7-45.6 4.7s-3.3-18.7-3.7-22.1l-.1-.8.7-.2c16.8-5.3 33.2-7.9 50.3-7.9 14.4 0 29.7 1.8 46.8 5.5l.7.2v.7c0 9.6-3.6 24.6-3.6 24.6s-29.6-4.7-45.5-4.7z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.712,
    y1: 143.493,
    x2: 288.397,
    y2: 143.493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c0d0d"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M286 158.1c-30.4-6.5-60.3-6.9-90.8-.3-1.2-7.9-2.6-13.5-3.5-21.1 31.2-9.9 60.7-10.2 96.7-2.3 0 9.6-2 23.8-2.4 23.7z",
    fill: "url(#top_view_truck_svg__SVGID_13_)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.397,
    y1: 142.645,
    x2: 274.276,
    y2: 142.645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.3 155.2c19.5-2.5 39.5-2.5 59 .2l3.9-23.3c-22.1-2.9-44.7-3-66.9-.2l4 23.3z",
    fill: "url(#top_view_truck_svg__SVGID_14_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st0",
    d: "M302.6 425.5h-125c-2 0-3.7-1.7-3.7-3.7V216.1c0-2 1.7-3.7 3.7-3.7h125c2 0 3.7 1.7 3.7 3.7v205.7c0 2.1-1.7 3.7-3.7 3.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M183.1 221.7H297v194.6H183.1z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.925,
    y1: 323.441,
    x2: 251.594,
    y2: 323.441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M223.9 266.9c-2.2-26.6-22.8-34.5-40.8-36.3v185.7h62.6c10.7-39.3-12.7-55.6-25.3-75-13.9-21.5 7.5-26.5 3.5-74.4z",
    fill: "url(#top_view_truck_svg__SVGID_15_)"
  })));
}

export default SvgTopViewTruck;